export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9881.ca7ac494.jpg";